let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bug2c")).then(() => parcelRequire('8Ib5W'));